export const mapOfficeCategory = {
  pusat: 'Pusat',
  stockist_center: 'Stockist Center',
  kantor_pelayanan: 'Kantor Pelayanan',
  stockist: 'Stockist',
  supplier: 'Supplier',
  member: 'Mitra Usaha',
};
